import * as React from "react";
const SvgBatteryVertical100PercentCharging20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M13 0v2h3v18H4V2h3V0h6Zm-1.75 6L5 12.25h5L8.75 16 15 9.75h-5L11.25 6Z",
      clipRule: "evenodd"
    })
  );
export default SvgBatteryVertical100PercentCharging20Px;
